import { create } from "zustand";

interface ScrollableOverlayStore {
  isDealerContextSelectorOpen: boolean;
  setDealerContextSelectorOpen: (open: boolean) => void;
}

export const useScrollableOverlayStore = create<ScrollableOverlayStore>()(
  (set) => ({
    isDealerContextSelectorOpen: false,
    setDealerContextSelectorOpen: (open) =>
      set({ isDealerContextSelectorOpen: open }),
  }),
);

export const getScrollableOverlayStore = () =>
  useScrollableOverlayStore.getState();
